export enum PERMISSIONS {
  Role = 'role',
  TeamAdmin = 'teamAdmin',
  ResourceAdmin = 'resourceAdmin',
  DataStructureAdmin = 'dataStructureAdmin',
  RequirementsManager = 'requirementsManager',
  ReleaseAdmin = 'releaseAdmin',
  UrlLibraryManager = 'urlLibraryManager',
  ImportManager = 'importManager',
  WorkflowIntegrationManager = 'workflowIntegrationManager'
}
